// @ts-nocheck

import React, { Component, Fragment } from 'react';

import './root.scss';

import { updateTitle } from '@/v2/helpers/other/strings';
import { getEnvelope } from '@/v2/wallet/envelope/envelope.service';
import RootProvider, { RootContext, StateContext } from './root.provider.tsx';
import { isMobile } from '@/v2/helpers/device';
import { T } from '@/helpers/i18n';
import Spinner from '@/v2/partials/spinner/spinner.tsx';
import { MultiEventEnvelopeModel } from '@/v2/models/multiEventEnvelopeModel.ts';
import Desktop from '@/v2/desktop/desktop.tsx';
import Header from '@/v2/header/header.tsx';
import Wallet from '@/v2/wallet/wallet.tsx';

type State = {
  loading: boolean;
  envelope: MultiEventEnvelopeModel;
  err: any;
};

class Root extends Component<T, State> {
  static contextType: React.Context<StateContext> = RootContext;
  token: string = window.location.pathname.substring(1);

  state: State = {
    loading: true,
    envelope: null,
    err: null,
  };

  async componentDidMount() {
    if (this.token) {
      try {
        const { data: envelope } = await getEnvelope(this.token);

        this.setState({ envelope }, async () => {
          this.setState({ loading: false });
        });
      } catch (err: any) {
        this.setState({ err }, async () => {
          this.setState({ loading: false });
        });
      }
    } else {
      this.setState({ loading: false });
    }
  }

  render() {
    updateTitle();

    const { loading, envelope, err } = this.state;
    const isMobileDevice: boolean = isMobile.any();

    if (loading) {
      return isMobileDevice ? <></> : <Spinner isShown={true} />;
    }

    return (
      <RootProvider>
        {!isMobileDevice ? (
          <Desktop envelope={envelope} err={err} />
        ) : (
          <Fragment>
            <Header envelope={envelope} />
            <Wallet envelope={envelope} err={err} />
          </Fragment>
        )}
      </RootProvider>
    );
  }
}

export default Root;
